import _default from './Select';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/addons/Select/index.js
// module id = 468
// module chunks = 0